import { createContext, SetStateAction, Dispatch } from 'react';

type TContext = {
	dir: 'vertical' | 'horizontal',
	verticalDateWidth: number;
	setVerticalDateWidth: Dispatch<SetStateAction<number>>;
}

export const Context = createContext<TContext>({
	dir: 'vertical',
	verticalDateWidth: 0,
	setVerticalDateWidth: () => {}
});
